import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import Slide from '@material-ui/core/Slide';
import classNames from 'classnames';

import Question from './Question';
import Answer from './Answer';
import AAPlayerWrapper from './AAPlayerWrapper';
import Feedback from './Feedback';

const styles = (theme) => ({
	root: {
		overflow: 'hidden'
	},
	hidden: {
		display: 'none'
	},
	answers: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		paddingTop: theme.spacing.unit * 3,
		marginBottom: theme.spacing.unit * 4,
		borderTop: `1px solid ${grey[200]}`,
	},
});

class Item extends Component {
	renderAnswers() {
		const { classes, answers, index, answered, visible } = this.props;

		return (
			<div className={classes.answers}>
				{
					answers.map((answer, i) => {
						const text = answer._;
						const correct = Boolean(answer.$ && answer.$.correct === 'true');

						return <Answer visible={visible} itemIndex={index} index={i} text={text} correct={correct} questionAnswered={answered} key={text} />;
					})
				}
			</div>
		);
	}

	render() {
		const { classes, index, visible, question, answered, questionNum } = this.props;

		return (
			<div className={classNames(classes.root, { [classes.hidden]: !visible })}>
				<Slide direction="right" timeout={answered ? 0 : 300} in={visible}>
					<Question text={question} questionNum={questionNum} />
				</Slide>
				{this.renderAnswers()}
				<AAPlayerWrapper itemIndex={index} />
				<Feedback answered={answered} />
			</div>
		);
	}
}

Item.propTypes = {
	classes: PropTypes.object.isRequired,
	question: PropTypes.string.isRequired,
	answers: PropTypes.array.isRequired,
	index: PropTypes.number.isRequired,
	visible: PropTypes.bool.isRequired,
	answered: PropTypes.bool.isRequired,
	questionNum: PropTypes.number,
};

Item.defaultProps = {
	questionNum: undefined
};

function mapStateToProps({ exercise: { currentItem, answersSelected, autoNum }, loader: { testSent } }, ownProps) {
	return {
		visible: currentItem === ownProps.index,
		answered: Boolean(answersSelected[ownProps.index] !== undefined) || testSent,
		questionNum: autoNum ? ownProps.index + 1 : undefined
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Item);
